"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmChannel = void 0;
const topic_1 = require("../../topic");
const CRM_CHANNEL = 'crm';
class CrmChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = CRM_CHANNEL;
        this.topics = {
            CTA_RICH_Open: new topic_1.Topic('CTA_RICH_Open', CRM_CHANNEL, this._logger),
            CTA_ExternalLink_Open: new topic_1.Topic('CTA_ExternalLink_Open', CRM_CHANNEL, this._logger),
            OPEN_SURVEY: new topic_1.Topic('OPEN_SURVEY', CRM_CHANNEL, this._logger),
            TOURNAMENT_TICKETS: new topic_1.Topic('TOURNAMENT_TICKETS', CRM_CHANNEL, this._logger),
            TOURNAMENT_TICKETS_TAB_OPENED: new topic_1.Topic('TOURNAMENT_TICKETS_TAB_OPENED', CRM_CHANNEL, this._logger),
            ELIGIBILITY_DATA: new topic_1.Topic('ELIGIBILITY_DATA', CRM_CHANNEL, this._logger)
        };
    }
}
exports.CrmChannel = CrmChannel;
//# sourceMappingURL=crm.channel.js.map